import CommonActions from '../actions/actions';
import FBActions from '../actions/FacebookSessionCRUDActions';
import Actions from '../actions/SessionCRUDActions';
import usersCRUDActions from '../actions/UsersCRUDActions';
import AuthenticatedController from '../controllers/AuthenticatedController';
import { SessionObject, SessionState } from '../interfaces/session';
import { setBusy, setUnBusy } from './common/commonReducers';
import { omit } from 'lodash';

function getStoredSession() {
  let session;
  try {
    session = AuthenticatedController.getSession();
    const now = new Date();
    if (session.expiresAt < now) {
      // Clear old sessions
      AuthenticatedController.clearSession();
      session = null;
    }
  } catch (e) {
    session = null;
  }
  return session;
}

const initialState: SessionState = {
  session: getStoredSession(),
  loggedOut: false,
  busy: false,
  inviteToken: '',
  inviteCompanyName: '',
  errorMessage: '',
};

const updateUserAttributes = (state: SessionState, action): SessionState => {
  const { userAttributes } = action.payload;

  const session = {
    ...state.session,
    userAttributes: {
      ...state.session.userAttributes,
      ...userAttributes,
    },
  };

  if (session) {
    AuthenticatedController.storeSession(session as SessionObject);
  }

  return {
    ...state,
    session,
  };
};

export default function session(state: SessionState = initialState, action) {
  switch (action.type) {
    case Actions.busyAction:
      return setBusy(state);
    case Actions.retrievedAction: {
      return {
        ...state,
        session: action.entity,
        errorMessage: '',
        busy: false,
      };
    }
    case Actions.updateAction: {
      const session = { ...state.session, ...action.session };
      AuthenticatedController.updateSession(session);

      return {
        ...state,
        session,
      };
    }
    case FBActions.retrievedAction: {
      return {
        ...state,
        session: action.entity,
        loggedOut: false,
        errorMessage: '',
      };
    }

    case Actions.getMyUserAction: {
      return {
        ...state,
        session: {
          ...state.session,
          ...omit(action.payload, 'authToken'),
        },
      };
    }

    case Actions.clearSessionAction: {
      return {
        ...state,
        session: null,
        loggedOut: true,
        busy: false,
        errorMessage: action.errorMessage,
        inviteToken: '',
      };
    }
    case Actions.setInviteTokenAction: {
      return {
        ...state,
        inviteToken: action.inviteToken,
        inviteCompanyName: action.companyName,
      };
    }
    case Actions.resetInviteTokenAction: {
      return {
        ...state,
        inviteToken: '',
        inviteCompanyName: '',
      };
    }
    case usersCRUDActions.updateUserAttributesSessionAction:
      return updateUserAttributes(state, action);
    case usersCRUDActions.updatePapAffiliateAction:
      return {
        ...state,
        papAffiliate: action.papAffiliate,
      };
    case CommonActions.UNBUSY:
    case Actions.unbusyAction:
      return setUnBusy(state);
    default: {
      return state;
    }
  }
}
